import React from 'react'
import { Skeleton } from "@chakra-ui/react"

const AdvertiserCampaigns = () => {
    return (
        <div className="station-table-container" style={{marginTop: "20px"}}>
            <table>
                <thead>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="40px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="60px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="60px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="15px" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="30px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="100px" height="20px" />
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="30px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="100px" height="20px" />
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="30px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="100px" height="20px" />
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="30px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="100px" height="20px" />
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <Skeleton width="15px" height="15px" />
                        </th>
                        <th>
                            <Skeleton width="30px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="75px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="80px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="70px" height="20px" />
                        </th>
                        <th>
                            <Skeleton width="100px" height="20px" />
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default AdvertiserCampaigns